import Variable from "../../Helpers/Variable";
import Language from "../../Helpers/Language";
import ScheduleLocalFilter from "../Services/ScheduleLocalFilter";

export default class SortableSchedules {
    constructor(schedules) {
        if (schedules instanceof ScheduleLocalFilter) {
            this.originalSchedules = schedules.getOriginalSchedules();
            this.filteredSchedules = schedules.getFilteredSchedules();
        } else {
            this.originalSchedules = schedules;
            this.filteredSchedules = schedules;
        }
    }

    sort() {
        this.sortedSchedules = this.filteredSchedules.sort((firstSchedule, secondSchedule) => {
            if (new Date(firstSchedule['start']) > new Date(secondSchedule['start'])) {
                return 1;
            }

            if (new Date(firstSchedule['start']) < new Date(secondSchedule['start'])) {
                return -1;
            }

            return 0;
        });

        return this;
    }

    groupByStartDate() {
        let groupedSchedules = {};

        (this.sortedSchedules ?? this.filteredSchedules).forEach((schedule) => {
            let date = new Date(schedule['start']).toLocaleTimeString(Language.getLanguage() ?? null, {
                hour: "2-digit",
            });

            if (Language.isPortuguese()) {
                date += ':00';
            }

            if (date in groupedSchedules) {
                groupedSchedules[date].push(schedule);
            } else {
                groupedSchedules[date] = [schedule];
            }
        });

        this.groupedSchedules = groupedSchedules;

        return this;
    }

    getSortedSchedules() {
        return this.sortedSchedules ?? this.sort().getSortedSchedules();
    }

    getOriginalSchedules() {
        return this.originalSchedules;
    }

    getGroupedSchedules() {
        return this.groupedSchedules ?? this.groupByStartDate().getGroupedSchedules();
    }
}
